import { Configuration, LogLevel } from "@azure/msal-browser";

const tenantName = import.meta.env.VITE_ENTRA_TENANT_NAME;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
const apiClientId = import.meta.env.VITE_ENTRA_API_CLIENT_ID;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://${tenantName}.ciamlogin.com/`,
    knownAuthorities: [`${tenantName}.ciamlogin.com`],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error(message);
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${apiClientId}/access`],
};

export const apiScopes = {
  access: [`api://${apiClientId}/access`],
};

// A customer changes their own password with Microsoft Graph, acting as themselves. The permission has
// to be admin-consented on this app registration in each external tenant.
export const graphScopes = {
  changePassword: ["https://graph.microsoft.com/User-PasswordProfile.ReadWrite.All"],
};
